import React from 'react';
import {useControllerProps, UseControllerPropsResult} from '../../../../../../domain/controllers/ControllerContext';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {TextButton} from 'wix-ui-tpa/cssVars';

export enum ItemLinkDataHooks {
  Anchor = 'ItemLinkDataHooks.Anchor',
  NonClickableItem = 'ItemLinkDataHooks.NonClickableItem',
}

const handleClick = ({
  event,
  navigationStore,
  fullUrl,
}: {
  event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>;
  navigationStore: UseControllerPropsResult['navigationStore'];
  fullUrl: string;
}) => {
  event.preventDefault();
  event.stopPropagation();
  return navigationStore.navigateToUrl(fullUrl);
};

export const ItemLink = ({
  lineItem,
  children,
  tabIndex,
  className,
}: {
  lineItem: LineItemModel;
  children: React.ReactChild;
  tabIndex?: number;
  className?: string;
}) => {
  const {navigationStore} = useControllerProps();
  const href = lineItem.attributes.url.url;

  if (!href) {
    return <div data-hook={ItemLinkDataHooks.NonClickableItem}>{children}</div>;
  }
  const onClickHandler = (event) =>
    handleClick({
      event,
      navigationStore,
      fullUrl: lineItem.attributes.url.url,
    });

  return (
    <TextButton
      as="a"
      className={className}
      style={{textDecoration: 'none'}}
      href={href}
      onClick={onClickHandler}
      {...(tabIndex !== undefined ? {tabIndex} : {})}
      data-hook={ItemLinkDataHooks.Anchor}>
      {children}
    </TextButton>
  );
};
